import { render, staticRenderFns } from "./RegistrationPersonalDetailsStep.vue?vue&type=template&id=c3efda64&"
import script from "./RegistrationPersonalDetailsStep.vue?vue&type=script&lang=ts&"
export * from "./RegistrationPersonalDetailsStep.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports